module.exports = __webpack_public_path__ + "static/media/partnerAdvantage1.a6c26eff.svg";